import React, { useEffect, useRef, useState, useMemo } from 'react';
import { Link as PageLink } from 'react-router-dom';
import { Link, animateScroll as scroll } from "react-scroll";
import { Link as LinkRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth0 } from "@auth0/auth0-react";
import './styles.css';
import LanguageIcon from '@mui/icons-material/Language';
import PasswordIcon from '@mui/icons-material/Password';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Grid, Card, CardContent, Typography, Select, MenuItem, FormControl, TextField, Button } from '@mui/material';
import { styled } from '@mui/system';
import { UsageTable } from '../UsageTable';
import { updateUserData } from "../../services/api.service";
import axios from 'axios';
import { getUserUsage } from "../../services/api.service";
import { BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Bar } from 'recharts';

const ActionContent = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(50px, 1fr))',
    justifyContent: 'center',
    gridAutoRows: 'minmax(0, 1fr)',
    gridTemplateRows: 'repeat(2, minmax(0, 1fr))',
    gap: 100,
    padding: "10% 5%",
    marginBottom: "-8%"
});

export const StackedBarChart = ({data, measureType}) => {

    return (
      <BarChart
        width={500}
        height={300}
        data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip />
        <Legend />
        {measureType == 'metric' ? (
            <>
                <Bar dataKey="frames" stackId="a" fill="#8884d8" />
                <Bar dataKey="seconds" stackId="a" fill="#82ca9d" />
                <Bar dataKey="images" stackId="a" fill="#ffc658" />
                <Bar dataKey="chars" stackId="a" fill="#FF8042" />
            </>
        ) : (
            <>
                <Bar dataKey="video" stackId="a" fill="#8884d8" />
                <Bar dataKey="audio" stackId="a" fill="#82ca9d" />
                <Bar dataKey="image" stackId="a" fill="#ffc658" />
                <Bar dataKey="text" stackId="a" fill="#FF8042" />
            </>
        )}
        
      </BarChart>
    );
  }

export const MyAccount = () => {
    const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
    const [userUsage, setUserUsage] = useState([]);
    const [measureType, setMeasureType] = useState([]);

    const loadUserUsage = async () => {
        const data = (await getUserUsage()).data
        let raw = data.monthly_data
        let measureType = data.measure_type;
        
        let usage = []
        for(const key of Object.keys(raw).sort()) {
            let element = raw[key]
            element['month'] = key
            usage.push(element)
        }
        setUserUsage(usage)
        setMeasureType(measureType)
    }

    useEffect(() => {
        (async () => {
            try {
              await loadUserUsage()
            } catch (e) {
              console.error(e);
            }
        })();
    }, [isAuthenticated])

    const notifySuccess = () => toast.success("Data updated successfully!");
    const notifyFailure = () => toast.error("Your data failed updating!");

    const [updateUserDataLoading, setUpdateUserDataLoading] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");

    const updateUserDataAndNotify = async () => {
        setUpdateUserDataLoading(true);
        const response = await updateUserData(name, email);
        setUpdateUserDataLoading(false);

        if (response.status == 200 || response.status == 201) {
            notifySuccess();
        } else {
            notifyFailure();
        }
    };

    useEffect(() => {
        if(user?.name ?? false) setName(user.name);
        if(user?.email ?? false) setEmail(user.email);
    }, [user])

    return isAuthenticated && (
        <div className="page-container">
            <Grid container spacing={2}>
                <Grid item xs={4} sx={{ overflow: "unset" }}>
                    <div className='menuContainer'>
                        <div className='menuMainText'>
                            <div className='menuHeader'>
                                <img src="https://deepid-assets.s3.amazonaws.com/all_images/logo_deepid.png" width={72} height={45} />
                                <PageLink to="/dashboard" style={{ textDecoration: 'none', color: 'white' }}>
                                    <div className='goBack'>
                                        <ArrowBackIcon />
                                        Go back
                                    </div>
                                </PageLink>
                            </div>
                            <Typography variant="h2" sx={{ paddingTop: "5%", fontSize: 40, lineHeight: 1.2, marginBottom: "1%", fontWeight: 800, color: "#999999" }}>My account</Typography>
                            <Typography variant="h5" sx={{ fontSize: 16, lineHeight: 1.2, fontWeight: 500, color: "#666666" }}>Manage all account settings in one place</Typography>
                        </div>
                        <div className='menuOptions'>
                            <Link
                                activeStyle={{
                                    fontWeight: 'bold'
                                }}
                                to="account"
                                spy={true}
                                smooth={true}
                                offset={-50}
                                duration={500}
                            >
                                <Typography sx={{ color: "#666666" }}>Profile</Typography>
                            </Link>
                            <hr color="#666666" />
                            <Link
                                activeStyle={{
                                    fontWeight: 'bold'
                                }}
                                to="usage"
                                spy={true}
                                smooth={true}
                                offset={0}
                                duration={500}
                            >
                                <Typography sx={{ color: "#666666" }}>Usage</Typography>
                            </Link>
                        </div>
                    </div>
                </Grid>
                <Grid item xs={8}>
                    <div className='actionContainer'>
                        <Card sx={{ background: "#222222", maxWidth: "100%", borderRadius: "32px", margin: "5%" }}>
                            <ActionContent id="account">
                                <div className='profileActionPart' style={{ color: "#888888" }}>
                                    <Typography variant="h4" sx={{ fontSize: 24, lineHeight: 1.2, marginBottom: "1%", fontWeight: "medium" }}>Profile</Typography>
                                    <Typography variant="h5" sx={{ fontSize: 18, lineHeight: 1.2, fontWeight: "light" }}>Here you can update and see your personal information.</Typography>
                                </div>
                                <div className='profileActionPart'>
                                    <div className="inputContainer">
                                        <Typography sx={{ marginTop: "5%", marginRight: "7%" }}>Name: </Typography>
                                        <TextField fullWidth={true} label="Input your name here" variant="filled" sx={{ borderRadius: "8px" }} value={name} onChange={(e) => setName(e.target.value)} />
                                    </div>
                                    <div className="inputContainer">
                                        <Typography sx={{ marginTop: "10%", marginRight: "7%" }}>Email: </Typography>
                                        <TextField fullWidth={true} label="Input your email here" variant="filled" sx={{ borderRadius: "8px", marginTop: "5%" }} value={email} onChange={(e) => setEmail(e.target.value)} />
                                    </div>
                                    <Button variant="contained" disabled={true} fullWidth={true} sx={{ marginTop: "5vh", minHeight: "8vh", borderRadius: "16px 0px 16px 0px", backgroundColor: "#4455bb" }} onClick={() => updateUserDataAndNotify()}>
                                        Coming soon!
                                    </Button>
                                </div>
                                <div className='profileActionPart' style={{ color: "#888888" }}>
                                    <PasswordIcon fontSize="large" sx={{ color: "rgb(130, 130, 130)" }} />
                                    <Typography variant="h5" sx={{ fontSize: 18, lineHeight: 1.2, fontWeight: "light" }}>Don't forget to change your password often.</Typography>
                                    <Typography variant="h5" sx={{ fontSize: 18, lineHeight: 1.2, fontWeight: "light" }}>Update your password, Here.</Typography>
                                </div>
                                <div className='profileActionPart' style={{ color: "#888888" }}>
                                    <LanguageIcon fontSize="large" sx={{ color: "rgb(130, 130, 130)" }} />
                                    <div className="languagePickerContainer">
                                        <Typography variant="h5" sx={{ fontSize: 18, lineHeight: 1.2, marginRight: "5%" }}>Language: </Typography>
                                        <FormControl variant="standard">
                                            <Select
                                                label="Language"
                                                defaultValue="en"
                                                sx={{
                                                    marginTop: "-5%",
                                                    color: "#666666"
                                                }}
                                            >
                                                <MenuItem value="en">English</MenuItem>
                                                <MenuItem value="fr">French</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                            </ActionContent>
                        </Card>
                        <Card sx={{ background: "#222222", maxWidth: "100%", borderRadius: "32px", margin: "5%" }}>
                            <CardContent id="usage" sx={{ padding: "10% 5%" }}>
                                <div className='usageRowContainer'>
                                    <div className='profileActionPart' style={{ color: "#888888" }}>
                                        <Typography variant="h4" sx={{ fontSize: 24, lineHeight: 1.2, marginBottom: "1%", fontWeight: "medium" }}>Usage</Typography>
                                        <Typography variant="h5" sx={{ fontSize: 18, lineHeight: 1.2, paddingRight: "45%" }}>Here you can see the pricing and usage history.</Typography>
                                    </div>
                                    <div className='profileActionPart'>
                                        <StackedBarChart data={userUsage} measureType={measureType} />
                                    </div>
                                </div>
                                <UsageTable userUsage={userUsage} measureType={measureType} />
                            </CardContent>
                        </Card>
                    </div>
                </Grid>
            </Grid>
        </div>
    );
}